import { NavLink } from "react-router-dom";

const UserNavBar = () => {
  return (
      <nav>
		  <ul>
			  <li>
				  <NavLink to="/addUser">Add Users</NavLink>
			  </li>
			  <li>
				  <NavLink to="/editUser">Edit Users</NavLink>
			  </li>
			  <li>
				  <NavLink to="/deleteUser">Delete Users</NavLink>
			  </li>
			  <li>
				  <NavLink to="/restoreUser">Restore Deleted Users</NavLink>
			  </li>
		  </ul>
      </nav>
  );
};

export default UserNavBar
